// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA0mCzB_c899SCzDrz7ACql469SEMw5v4Y",
  authDomain: "internskool-d3e2f.firebaseapp.com",
  projectId: "internskool-d3e2f",
  storageBucket: "internskool-d3e2f.firebasestorage.app",
  messagingSenderId: "127523354054",
  appId: "1:127523354054:web:6dadd546e15c26da326ec7",
  measurementId: "G-SY66T56EXM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);

export const auth = getAuth(app);

// Modify exports to include auth
export { app, db, storage, analytics, }; // Add app to exports